module.exports = __webpack_public_path__ + "static/media/ic-gg.107d5614.svg";